import React from 'react';

const CAMPAIGN_STATUSES = {
  planned: {
    label: 'Planned',
    color: 'bg-yellow-100 text-yellow-800'
  },
  active: {
    label: 'Active',
    color: 'bg-green-100 text-green-800'
  },
  completed: {
    label: 'Completed',
    color: 'bg-blue-100 text-blue-800'
  },
  paused: {
    label: 'Paused',
    color: 'bg-gray-100 text-gray-800'
  }
};

const CampaignStatusSelect = ({ status, onStatusChange, disabled = false }) => {
  return (
    <select
      value={status}
      onChange={(e) => onStatusChange(e.target.value)}
      disabled={disabled}
      className={`px-3 py-1 rounded-full text-sm font-medium ${
        CAMPAIGN_STATUSES[status]?.color || 'bg-gray-100 text-gray-800'
      } border-0 focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
      }`}
    >
      {Object.entries(CAMPAIGN_STATUSES).map(([value, { label }]) => (
        <option key={value} value={value}>
          {label}
        </option>
      ))}
    </select>
  );
};

export default CampaignStatusSelect; 